import React, { MouseEventHandler, useEffect } from 'react';
import { useAppSelector, useAppDispatch } from 'flow/hooks/useRedux';
import { TypedMap } from 'flow/types/TypedMap';
import Divider from 'flow/components/ui-components/Divider';
import Toggle from 'flow/components/ui-components/Toggle';
import useAppContext from 'flow/hooks/useAppContext';
import { Profile } from 'flow/types/Profile';

import Page from '../../Page';
import SettingRow from '../../SettingRow';
import { Busy as BusyLogic } from '../components/CallSettings';
import { toggleCallWaiting } from 'flow/actions/phone-actions';
import { loadCallWaitingEnabled } from 'flow/actions/app-actions';
import { fetchProfiles } from 'flow/actions/profile-actions';
import { ExtensionKey } from 'flow/types/EntityKeys';
import { useParams } from 'react-router-dom';

interface Props {
    profile: TypedMap<Profile>;
    onClickBack: MouseEventHandler;
}

const Busy = ({ profile, onClickBack }: Props) => {
    const { i18next } = useAppContext();
    const dispatch = useAppDispatch();

    const { extensionKey } = useParams<{
        extensionKey: ExtensionKey;
    }>();
    const phone = useAppSelector((state) => state.phone);

    useEffect(() => {
        dispatch(fetchProfiles(extensionKey));
        dispatch(loadCallWaitingEnabled(extensionKey));
    }, []);

    return (
        <Page onClickBack={onClickBack} header="settings.incoming_calls.busy">
            <BusyLogic profile={profile} />

            <Divider />

            {profile.get('available') && (
                <>
                    <SettingRow
                        dataTestId="call-waiting-toggler"
                        cta={
                            <Toggle
                                value={phone.getIn([
                                    'callWaiting',
                                    'callWaiting',
                                ])}
                                onChange={(e) =>
                                    dispatch(
                                        toggleCallWaiting(
                                            phone
                                                .get('callWaiting')
                                                .set('callWaiting', e),
                                        ),
                                    )
                                }
                                text={i18next.t('media.settings.callwaiting')}
                            />
                        }
                    >
                        {i18next.t('media.settings.callwaiting')}
                    </SettingRow>
                    <p className="mt-2 px-2 text-xs text-gray-500">
                        {i18next.t('media.settings.callwaiting_description')}
                    </p>
                </>
            )}
        </Page>
    );
};

export default Busy;
